import { Component } from '@angular/core';

@Component({
  selector: 'app-salfa-info-renta-actual',
  templateUrl: './salfa-info-renta-actual.component.html',
  styleUrls: ['./salfa-info-renta-actual.component.scss']
})
export class SalfaInfoRentaActualComponent {

}
